import Vue from "vue";
import VueRouter from "vue-router";
import Error from "../components/Error";
import Logout from "../components/Logout";
import Login from "../components/Login";
import Dashboard from "../components/Dashboard";
import ResourceSelect from "../components/ResourceSelect";
import TicketStore from "../components/TicketStore";
import Invite from "../components/Invite";
import PasswordReset from "../components/PasswordReset";
import PasswordRestore from "../components/PasswordRestore";
import Profile from "../components/Profile";
import ResourcesAccess from "../components/ResourcesAccess";
import CreateAccount from "../components/CreateAccount";
import PinSwitch from "../components/PinSwitch";

Vue.use(VueRouter);

export default new VueRouter({
    routes: [
        {
            path: "/",
            name: "home",
            component: Dashboard,
            meta: {
                title: 'Dashboard'
            }
        },
        {
            path: "/login",
            name: "login",
            component: Login,
            meta: {
                title: 'Login'
            }
        },
        {
            path: "/profile",
            name: "profile",
            component: Profile,
        },
        {
            path: "/logout",
            name: "logout",
            component: Logout,
        },
        {
            path: "/ticket/select",
            name: "ticketSelect",
            component: ResourceSelect
        },
        {
            path: "/resources/access",
            name: "resourcesAccess",
            component: ResourcesAccess
        },
        {
            path: "/account/new",
            name: "createAccount",
            component: CreateAccount
        },
        {
            path: "/ticket/:ticket",
            component: TicketStore,
        },
        {
            path: "/invite/:invite",
            name: "invite",
            component: Invite,
        },
        {
            path: "/password/reset",
            name: "passwordReset",
            component: PasswordReset,
            meta: {
                title: 'Password reset'
            }
        },
        {
            path: "/password/restore/:token",
            name: "passwordRestore",
            component: PasswordRestore,
            meta: {
                title: 'Password restore'
            }
        },
        {
            path: "/login/legacy",
            name: "legacy",
            component: Login,
            props: {
                defaultFormMode: 'legacy',
            },
            meta: {
                title: 'Login'
            }
        },
        {
            path: "/login/password",
            name: "password",
            component: Login,
            props: {
                defaultFormMode: 'password',
            },
            meta: {
                title: 'Login'
            }
        },
        {
            path: "/error",
            name: "error",
            component: Error,
            meta: {
                title: 'Error occurred'
            }
        },
        {
            path: "/login/:ticket/error",
            alias: "/login/error",
            component: Error,
            props: {message: "Sorry, something goes wrong. Please go back and try again."}
        },
        {
            path: "/login/*",
            component: Error,
            props: {message: "Page you are looking for not found"}
        },
        {
            path: "/pin-switch",
            component: PinSwitch,
            name: "pin-switch"
        }
    ],
    mode: "history"
});
